import React, { useRef, useState } from "react"
import PropTypes from "prop-types"
import styles from "./newsletterSubscribe.module.css"
import DiagonalArrowIcon from "./svg/diagonalArrowIcon"
import { API_URL, sendData } from "../../dataFetcher"
import CheckMarkInCircleIcon from "./svg/checkMarkInCircleIcon"
import { CSSTransition } from "react-transition-group"

export default function NewsletterSubscribe({ className }) {
  const inputRef = useRef(null)
  const submitButtonRef = useRef(null)

  const [inputFocus, setInputFocus] = useState(false)
  const [freezeForm, setFreezeForm] = useState(false)
  const [successfullySend, setSuccessfullySend] = useState(false)
  const [
    showSuccessfullySendMessage,
    setShowSuccessfullySendMessage,
  ] = useState(false)

  const submitHandler = event => {
    event.preventDefault()
    setFreezeForm(true)
    sendData(`${API_URL}/email-stores`, {
      email: inputRef.current.value,
    })
      .then(() => {
        console.log("ok....")
        setSuccessfullySend(true)
        setShowSuccessfullySendMessage(true)
      })
      .catch(() => {
        console.warn("email send error...")
        setFreezeForm(false)
      })
  }

  const arrowClickHandler = event => {
    submitButtonRef.current.click()
  }

  return (
    <div className={`${styles.wrapper} ${className}`}>
      <h3>
        Sign up for <br />
        our <span>newsletter</span>
      </h3>
      <p>subscribe for monthly graphica stories</p>
      <div className={styles.inputContainer}>
        <form onSubmit={submitHandler}>
          <input
            type="email"
            placeholder="email to subscribe"
            ref={inputRef}
            onFocus={() => {
              setInputFocus(true)
            }}
            onBlur={() => {
              setInputFocus(false)
            }}
            required={true}
            disabled={freezeForm}
          />
          <CSSTransition
            in={showSuccessfullySendMessage}
            timeout={{
              enter: 300,
              exit: 150,
            }}
            unmountOnExit={true}
            mountOnEnter={true}
            onEntered={() => {
              setTimeout(() => {
                setShowSuccessfullySendMessage(false)
              }, 3000)
            }}
            classNames={{
              enter: styles.enter,
              enterActive: styles.enterActive,
              exit: styles.exit,
              exitActive: styles.exitActive,
            }}
          >
            <div className={styles.successSubscribeMessageContainer}>
              <div className={styles.successSubscribeMessage}>
                subscribed successfully!
              </div>
            </div>
          </CSSTransition>
          <button
            type="submit"
            style={{ display: "none" }}
            ref={submitButtonRef}
          >
            .
          </button>
        </form>
        {!successfullySend && (
          <DiagonalArrowIcon
            className={`${styles.inputArrow} ${inputFocus ? styles.focus : ""}`}
            onClick={arrowClickHandler}
          />
        )}
        {successfullySend && (
          <CheckMarkInCircleIcon className={styles.checkMarkIcon} />
        )}
      </div>
    </div>
  )
}

NewsletterSubscribe.propTypes = {
  className: PropTypes.string,
}

NewsletterSubscribe.defaultProps = {
  className: "",
}
